import React from 'react';
import { useGoogleTranslate } from '../../Hooks/useGoogleTranslate';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/home-figma/logo-figma.png';
import StoreGoogleBadge from '../../assets/images/home-figma/store-google.svg?react';
import StoreAppleBadge from '../../assets/images/home-figma/store-apple.svg?react';
import { APP_STORE_URLS, isStoreLinkReady } from '../../Utils/Constants/appStores';
// import socialFacebook from '../../assets/images/home-figma/social-facebook.png';
// import socialInstagram from '../../assets/images/home-figma/social-instagram.png';
// import socialDribbble from '../../assets/images/home-figma/social-dribbble.png';
// import socialSnapchat from '../../assets/images/home-figma/social-snapchat.png';
// import socialTiktok from '../../assets/images/home-figma/social-tiktok.png';
import './Footer.css';

const Footer = ({ variant = 'default' }) => {
  const currentYear = new Date().getFullYear();

  const homeLabel = useGoogleTranslate('Home');
  const giftShopLabel = useGoogleTranslate('Gift Shop');
  const coinStoreLabel = useGoogleTranslate('Coin Store');
  const subscriptionPlansLabel = useGoogleTranslate('Subscription Plans');
  const aboutUsLabel = useGoogleTranslate('About Us');
  const contactUsLabel = useGoogleTranslate('Contact Us');
  const howToUseLabel = useGoogleTranslate('How to Use');
  const copyrightText = useGoogleTranslate("Copyright © 2026 - let's plan a date. All rights reserved.");
  const downloadAppLabel = useGoogleTranslate('Download the App');

  const footerLinks = [
    { label: homeLabel, link: '/' },
    { label: aboutUsLabel, link: '/about-us' },
    { label: howToUseLabel, link: '/how-to-use' },
    { label: giftShopLabel, link: '/gift-store' },
    { label: coinStoreLabel, link: '/coin-store' },
    { label: subscriptionPlansLabel, link: '/subscription-plans' },
    { label: contactUsLabel, link: '/contact-us' },
  ];

  const handleStoreClick = (event, url) => {
    if (!isStoreLinkReady(url)) {
      event.preventDefault();
    }
  };

  if (variant === 'home-header') {
    return (
      <footer className="footer-main-container footer-figma">
        <div className="appContainer footer-figma__container">
          <div className="footer-figma__top">
            <Link to="/" className="footer-figma__logo">
              <img src={logo} alt="Danty" />
            </Link>
            <div className="footer-figma__download">
              <p className="footer-figma__download-title">{downloadAppLabel}</p>
              <div className="footer-figma__stores">
                <a
                  href={APP_STORE_URLS.googlePlay}
                  className="footer-figma__store-badge"
                  aria-label="Get it on Google Play"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => handleStoreClick(e, APP_STORE_URLS.googlePlay)}
                >
                  <StoreGoogleBadge />
                </a>
                <a
                  href={APP_STORE_URLS.appleAppStore}
                  className="footer-figma__store-badge footer-figma__store-badge--apple"
                  aria-label="Download on the App Store"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => handleStoreClick(e, APP_STORE_URLS.appleAppStore)}
                >
                  <StoreAppleBadge />
                </a>
              </div>
            </div>
            {/* <div className="footer-figma__socials">
              {[socialFacebook, socialInstagram, socialDribbble, socialSnapchat, socialTiktok].map((icon) => (
                <img key={icon} src={icon} alt="" />
              ))}
            </div> */}
          </div>

          <nav className="footer-figma__links">
            {footerLinks.map((link) => (
              <Link key={link.link} to={link.link}>
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="footer-figma__divider" />
          <p className="footer-figma__copyright">{copyrightText}</p>
        </div>
      </footer>
    );
  }

  return (
    <footer className={`footer-main-container ${variant}`}>
      <div className="appContainer">
        <div className="footer-bottom-content">
          <div className="footer-policy-links">
            <Link to="/terms-and-conditions" className="footer-policy-link">
              Terms
            </Link>
            <Link to="/privacy-policy" className="footer-policy-link">
              Privacy
            </Link>
            <Link to="/refund-policy" className="footer-policy-link">
              Refund
            </Link>
            <Link to="/shipping-policy" className="footer-policy-link">
              Shipping
            </Link>
          </div>
          <div className="copyright">
            <p className="mb-0">{currentYear}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 